import './styles/Nav.css'
import homeLogo from './icons/home-interface-symbol.png'


export default function Nav({ setPage }) {

    function handleClick(e) {
        if(e.target.id === 'Home') {
            setPage('Home')
        } else {
            setPage(e.target.innerText)
        }
        
    }

    return (
        <>
            <div className='nav-bar'>       
                    <ul className='nav-list'>
                        <li onClick={handleClick}>
                            <img src={homeLogo} alt='Home' id='Home' className='home-logo'></img>
                            Home
                        </li>
                        <li onClick={handleClick}>
                            Portfolio
                        </li>
                        <li onClick={handleClick}>
                            About
                        </li>
                    </ul>
            </div>
        </>
    )
}